import { render, staticRenderFns } from "./StepTrust.vue?vue&type=template&id=28ddb336&"
import script from "./StepTrust.vue?vue&type=script&lang=js&"
export * from "./StepTrust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports